/**
 * Discounts Resource Client
 * Axios-based API client for discount/promotion code endpoints
 */
export class DiscountsResource {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Get applied discounts for a checkout session
     */
    async getAppliedDiscounts(sessionId) {
        return this.apiClient.get(`/api/v1/checkout-sessions/${sessionId}/promotions`);
    }
    /**
     * Apply a discount code to a checkout session
     */
    async applyDiscountCode(sessionId, code) {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/promotions/apply`, {
            code: code.trim(),
        });
    }
    /**
     * Remove a discount from a checkout session
     */
    async removeDiscount(sessionId, discountId) {
        return this.apiClient.delete(`/api/v1/checkout-sessions/${sessionId}/promotions/${discountId}`);
    }
}
